"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'reviewe',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  props: {
    user_type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    }
  },
  data: function data() {
    var _this = this;
    return {
      son_id: this.$route.query.son_id || '',
      form: {},
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      upbeginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.upend) {
            return time.getTime() > _this.form.upend || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      upendOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.upbegin) {
            return time.getTime() < _this.form.upbegin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      numInfo: {},
      stat_data: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        withdraw_status: this.$route.query.withdraw_status || '-1',
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      statusObj: {
        0: '发起提现申请',
        1: '等待上级审核',
        2: '上级审核不通过',
        3: '等待最终审核',
        4: '最终审核不通过',
        5: '审核完毕, 返现中',
        6: '返现已到账并确认'
      },
      agentInfo: {},
      // 提现总览
      overviewDialogVisible: false,
      // 控制对话框显示
      overviewLoading: false,
      // 加载状态
      overviewData: {},
      // 图表数据
      totalAmount: 0,
      // 添加合计金额
      // 已提现相关
      queryType: 2,
      // 查询类型：1-未提现，2-已提现
      queryDate: '',
      // 查询日期范围
      // 提现记录日志
      withdrawLogDialogVisible: false,
      withdrawLogLoading: false,
      withdrawLogList: [],
      withdrawLogRow: {}
    };
  },
  mounted: function mounted(options) {
    // 获取页面传参
    if (this.$route.query.callPages == "panelGroup") {
      // 首页跳转
      if (this.$route.name == "reviewe") {
        this.revieweShowDialog(); // 显示未提现总览对话框
      }
    }
    this.agentInfo = window.agentInfo;
    this.getNum();
    this.getList();
    this.$store.dispatch('user/postSetRecode', [1, 1, this.user_type]);
  },
  methods: {
    /**
     * 数量
     */
    getNum: function getNum() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        user_type: this.user_type
      });
      this.$get('agentapi/agent_withdraw_applys_stat_num', listQuery).then(function (res) {
        _this2.numInfo = res;
      });
    },
    showCode: function showCode(row) {
      var elem = document.createElement('img');
      elem.src = row.invoice;
      elem.style.width = '100%';
      elem.style.height = '100%';
      elem.style.position = 'fixed';
      elem.style.top = '0';
      elem.style.left = '0';
      elem.style.zIndex = '9999';
      document.body.appendChild(elem);
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      var exitFullscreen = function exitFullscreen() {
        if (!document.fullscreenElement) {
          document.body.removeChild(elem);
        }
      };
      document.addEventListener('fullscreenchange', exitFullscreen);
      elem.onclick = function () {
        document.exitFullscreen();
        document.body.removeChild(elem);
      };
    },
    /**
     * 显示提现记录日志弹窗
     * @param {Object} row
     */
    showWithdrawLog: function showWithdrawLog(row) {
      var _this3 = this;
      this.withdrawLogRow = row;
      this.withdrawLogDialogVisible = true;
      this.withdrawLogLoading = true;
      this.withdrawLogList = [];
      this.$get('agentapi/my_reviewe_apply', {
        aid: row.aid,
        limit: 10,
        withdraw_status: -1
      }).then(function (res) {
        _this3.withdrawLogLoading = false;
        _this3.withdrawLogList = res.list || [];
      }).catch(function () {
        _this3.withdrawLogLoading = false;
      });
    },
    /**
     * 关闭提现记录日志弹窗
     */
    handleWithdrawLogClose: function handleWithdrawLogClose() {
      this.withdrawLogDialogVisible = false;
      this.withdrawLogRow = {};
      this.withdrawLogList = [];
    },
    /**
     * 获取提现状态标签类型
     * @param {Number} status
     */
    getWithdrawStatusType: function getWithdrawStatusType(status) {
      var typeMap = {
        0: 'warning',
        1: 'warning',
        2: 'danger',
        3: 'warning',
        4: 'danger',
        5: 'primary',
        6: 'success',
        7: 'info'
      };
      return typeMap[status] || 'info';
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getNum();
      this.getList();
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab) {
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this4 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1,
          user_type: this.user_type
        }),
        url = 'agentapi/my_reviewe_apply';
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      if (listQuery.upbegin) listQuery.upbegin = this.parseTime(listQuery.upbegin, '{y}-{m}-{d}');
      if (listQuery.upend) listQuery.upend = this.parseTime(listQuery.upend, '{y}-{m}-{d}');
      if (listQuery.withdraw_status == 2 && this.checkRoles(['partner', 'terminal'])) {
        listQuery.withdraw_status = 4;
      }
      this.$get(url, listQuery).then(function (res) {
        _this4.listLoading = false;
        _this4.list = res.list;
        _this4.stat_data = res.stat_data;
        _this4.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this4.tableMaxH = window.innerHeight - _this4.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    /**
     * 审核提现
     * @param {Object} row
     */
    upApply: function upApply(row, agree) {
      var _this5 = this;
      if (agree == 1) {
        //判断phone和wx_mobile手机号是否一样,如果不一样提示下
        if (row.phone != row.wx_mobile && row.withdraw_type != 0) {
          this.$alert('手机号不一致,请确认手机号是否正确', '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this5.$alert('确定该笔提现申请通过审核吗？', '提现审核', {
                confirmButtonText: '确定',
                callback: function callback(action) {
                  if (action == 'confirm') {
                    _this5.postApply(row, agree);
                  }
                }
              });
            }
          });
        } else {
          this.$alert('确定该笔提现申请通过审核吗？', '提现审核', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              if (action == 'confirm') {
                _this5.postApply(row, agree);
              }
            }
          });
        }
      } else if (agree == 0) {
        this.$alert('确定驳回该笔提现申请吗？', '提现审核', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            if (action == 'confirm') {
              _this5.postApply(row, agree);
            }
          }
        });
      }
    },
    /**
     * 人工处理
     * @param row
     */
    virtualApply: function virtualApply(row) {
      var _this6 = this;
      this.$prompt('请输入备注', '人工处理', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this6.loadObj = _this6.$loading({
              lock: true,
              text: '正在提交',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;

            // 【操作埋点】2026-05-25 pc_withdraw_approve_1 人工处理提现
            _this6.$post('agentapi/virtual_review_apply', {
              apply_id: row.id,
              remarks: value
            }, {
              operation_option: '人工处理提现',
              content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name || '', "\u300D\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143\uFF0C\u5907\u6CE8\uFF1A").concat(value || '无'),
              operation_id: 'pc_withdraw_approve_1'
            }).then(function (res) {
              _this6.loadObj.close();
              _this6.$message({
                message: '提交成功',
                type: 'success'
              });
              _this6.toQuery();
            }).catch(function (err) {
              _this6.loadObj.close();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 提交选择结果
     * @param {Object} id
     * @param {Object} agree
     */
    postApply: function postApply(row, agree) {
      var _this7 = this;
      var url = 'agentapi/upper_review_apply';
      if (agentInfo.agent_level == 1) {
        url = 'agentapi/final_review_apply';
        if (agree == 0) {
          //需填写驳回原因
          this.$prompt('请输入驳回原因', '驳回申请', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'text',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                _this7.loadObj = _this7.$loading({
                  lock: true,
                  text: '正在提交',
                  spinner: 'el-icon-loading'
                });
                var value = instance.inputValue;

                // 【操作埋点】2026-05-25 pc_withdraw_reject_1 驳回提现（含原因）
                _this7.$post(url, {
                  apply_id: row.id,
                  agree: agree,
                  remarks: value
                }, {
                  operation_option: '驳回提现',
                  content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name, "\u300D\u7533\u8BF7\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143\uFF0C\u9A73\u56DE\u539F\u56E0\uFF1A").concat(value || '无'),
                  operation_id: 'pc_withdraw_reject_1'
                }).then(function (res) {
                  _this7.loadObj.close();
                  _this7.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  if (agentInfo.agent_level == 1) {
                    if (row.withdraw_type == 0 || row.withdraw_type == 3 || row.withdraw_type == 4) {
                      row.withdraw_status = agree == 0 ? 4 : 6;
                    } else {
                      row.withdraw_status = agree == 0 ? 4 : 5;
                    }
                  } else {
                    row.withdraw_status = agree == 0 ? 2 : 3;
                  }
                  _this7.toQuery();
                }).catch(function (err) {
                  _this7.loadObj.close();
                });
              } else {
                done();
              }
            }
          });
          return;
        }
      }

      // 【操作埋点】2026-05-25 pc_withdraw_approve_1 / pc_withdraw_reject_1 审核提现
      this.$post(url, {
        apply_id: row.id,
        agree: agree
      }, agree == 0 ? {
        operation_option: '驳回提现',
        content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name, "\u300D\u7533\u8BF7\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143"),
        operation_id: 'pc_withdraw_reject_1'
      } : {
        operation_option: '审核通过提现',
        content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name, "\u300D\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143\uFF0C\u624B\u7EED\u8D39 ").concat(row.withdraw_service_fee || 0, " \u5143\uFF0C\u5230\u8D26 ").concat(row.withdraw_money_get, " \u5143"),
        operation_id: 'pc_withdraw_approve_1'
      }).then(function (res) {
        _this7.$message({
          message: '提交成功',
          type: 'success'
        });
        if (agentInfo.agent_level == 1) {
          if (row.withdraw_type == 0 || row.withdraw_type == 3 || row.withdraw_type == 4) {
            row.withdraw_status = agree == 0 ? 4 : 6;
          } else {
            row.withdraw_status = agree == 0 ? 4 : 5;
          }
        } else {
          row.withdraw_status = agree == 0 ? 2 : 3;
        }
      });
    },
    // 显示未提现总览的对话框
    revieweShowDialog: function revieweShowDialog() {
      var _this8 = this;
      this.queryType = 2; // 默认显示已提现
      // 设置默认日期为今天
      var today = this.parseTime(Date.now(), '{y}-{m}-{d}');
      this.queryDate = [today, today];
      this.overviewDialogVisible = true;
      this.$nextTick(function () {
        _this8.fetchOverviewData();
      });
    },
    // 关闭订单交易统计弹窗
    handleOrderStatsClose: function handleOrderStatsClose(done) {
      var _this9 = this;
      this.$confirm('确认关闭？').then(function (_) {
        _this9.overviewDialogVisible = false;
        done();
      }).catch(function (_) {});
    },
    // 获取未提现总览数据
    fetchOverviewData: function fetchOverviewData() {
      var _this0 = this;
      this.overviewLoading = true;
      var params = {
        user_type: this.user_type,
        query_type: this.queryType
      };

      // 如果是已提现查询，添加日期参数
      if (this.queryType === 2) {
        if (this.queryDate) {
          params.query_date = this.queryDate[0] + '|' + this.queryDate[1];
        } else {
          // 默认查询今天
          var today = this.parseTime(Date.now(), '{y}-{m}-{d}');
          params.query_date = today + '|' + today;
        }
      }
      this.$get('agentapi/data_overview/overview_existing_amount', params).then(function (res) {
        _this0.overviewData = res;
        _this0.totalAmount = res.total_amount;
        _this0.$nextTick(function () {
          _this0.initChart();
        });
      }).catch(function (err) {
        console.error('获取总览数据失败:', err);
        _this0.$message.error('获取总览数据失败');
      }).finally(function () {
        _this0.overviewLoading = false;
      });
    },
    // 切换查询类型
    switchQueryType: function switchQueryType(type) {
      var _this1 = this;
      this.queryType = type;
      this.$nextTick(function () {
        _this1.fetchOverviewData();
      });
    },
    // 日期范围变化
    onDateRangeChange: function onDateRangeChange(dateRange) {
      var _this10 = this;
      this.queryDate = dateRange;
      this.$nextTick(function () {
        _this10.fetchOverviewData();
      });
    },
    // 初始化未提现总览的图表
    initChart: function initChart() {
      var echarts = require('echarts');

      // 销毁已有实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }

      // 初始化图表
      var chartContainer = this.$refs.chartContainer;
      if (!chartContainer) return;
      this.chartInstance = echarts.init(chartContainer);

      // 处理数据
      var categories = ["\u5408\u4F19\u4EBA\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.partner_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.partner_ratio || '0%'), "\u4EE3\u7406\u5546\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.agent_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.agent_ratio || '0%'), "\u4E1A\u52A1\u5458\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.salesman_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.salesman_ratio || '0%'), "\u5546\u5BB6\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.merchant_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.merchant_ratio || '0%'), "\u63A8\u5E7F\u5458\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.promoter_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.promoter_ratio || '0%'), "\u7528\u6237\u4F59\u989D\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.user_balance_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.user_balance_ratio || '0%'), "\u7528\u6237\u62BC\u91D1\n\n\u6570\u91CF\uFF1A".concat(this.overviewData.account_total_list.user_deposit_count || 0, "\n\n ").concat(this.overviewData.account_ratio_list.user_deposit_ratio || '0%')];
      var amounts = [this.overviewData.partner_amount || 0, this.overviewData.agent_amount || 0, this.overviewData.salesman_amount || 0, this.overviewData.merchant_amount || 0, this.overviewData.promoter_amount || 0, this.overviewData.user_deposit_amount || 0, this.overviewData.user_balance_amount || 0];

      // 图表配置
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var tooltip = params[0].name + '<br/>';
            // 确保值是数字类型再调用 toFixed
            var value = parseFloat(params[0].value);
            if (isNaN(value)) {
              value = 0;
            }
            tooltip += params[0].marker + params[0].seriesName + ': ¥' + value.toFixed(2);
            return tooltip;
          }
        },
        grid: {
          // 调整网格区域，为标签留出更多空间
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories
        },
        yAxis: {
          type: 'value',
          name: '金额(元)'
        },
        series: [{
          name: this.queryType === 1 ? '未提现金额' : '已提现金额',
          type: 'bar',
          data: amounts,
          itemStyle: {
            color: this.queryType === 1 ? '#91cc75' : '#5470c6' // 不同类型使用不同颜色
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              // 确保值是数字类型再调用 toFixed
              var value = parseFloat(params.value);
              if (isNaN(value)) {
                value = 0;
              }
              return '¥' + value.toFixed(2);
            }
          }
        }]
      };
      this.chartInstance.setOption(option);
    }
  }
};